import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import PlayerStore from "@/store/player";
import CreaturePanel from "@/scenes.ui/creature-panel";
import {ListView} from "@/scenes.ui/list-view";
import {ListService} from "@/services/list-service";
import Container = Phaser.GameObjects.Container;
import {VerticalLongPanel} from "@/scenes.ui/vertical-long-panel";
import {Keys} from "@/constants/key";
import GameObject = Phaser.GameObjects.GameObject;
import {CreatureUtils} from "@/utils/creature-utils";
import {Creature} from "@/store/level/types";

export class CreaturesGridView extends VerticalLongPanel {

    private static HEROES_IN_ROW = 4

    private listView!: ListView | null;

    constructor(scene: Scene, canvas: HTMLCanvasElement, callback: (creatureIndex: number) => void) {
        super(scene, canvas, Tr('vashi.geroi'));

        let self = this;
        SpriteUtils.scale(this, 1.15 / CU.S);

        let listPanelContainer: Container[] = [];

        let rowContainers: Container[] = [];

        let reversedNonTemporalCreaturesList = CreatureUtils.findNonTemporalCreatures(CreatureUtils.sortCreaturesAscending(PlayerStore.getPlayer().creatures));
        const orderedCreaturesList = CreatureUtils.getOrderedCreaturesList(reversedNonTemporalCreaturesList);

        orderedCreaturesList.forEach((c,i) => {
            let row = Math.floor(i /CreaturesGridView.HEROES_IN_ROW);
            if(!rowContainers[row]){
                rowContainers[row] = new Container(scene, 0, 0);
                listPanelContainer.push(rowContainers[row]);
                rowContainers[row].height = 180;
            }
            let panel: CreaturePanel = new CreaturePanel(scene,   -200 + i % CreaturesGridView.HEROES_IN_ROW * 120,  80, c, () => {}, true);
            panel.height = 0;
            panel.setHealthVisible();
            panel.setSmallClickAreaCallback(c,() => {
                let creatureIndex = 0;
                for (let creature of orderedCreaturesList){
                    if(creature.id == c.id){
                        break;
                    }
                    creatureIndex++;
                }                
                callback(creatureIndex);
                self.onClose();
            });
            rowContainers[row].add(panel);
        })

        let listView: ListView = new ListView(scene, canvas, listPanelContainer, (-canvas.width/2 + 362 * CU.S) , canvas.height / 2   - 300 * CU.S, 500 * CU.S, 600 * CU.S );
        listView.height = rowContainers.length * 200 / CU.S;
        this.listView = listView;

        this.scene.add.existing(listView);
        listView.setDepth(3002)

        this.on('destroy', function() {
            if(self.listView){
                self.listView.destroy();
            }
        });
    }

    protected onClose() {
        if(this.listView){
            this.listView!.destroy();
        }
        this.listView = null;
        super.onClose();
    }


}
